<template>
    <v-container fluid>
        <v-row class="align-center pl-3">
            <!-- Breadcrumbs -->
            <v-breadcrumbs
                :items="[
                    { text: 'Home', disable: false, href: '/#/' },
                    { text: 'Products', disabled: true }
                ]"
                divider="/"
            ></v-breadcrumbs>
            <v-spacer />
            <v-btn-toggle
                v-model="productFilterTab"
                class="mr-6"
                dense
                mandatory
                rounded
            >
                <v-btn small active-class="error--text"
                    >TO CONFIG<v-chip
                        x-small
                        class="ml-1 pa-1"
                        color="red"
                        text-color="white"
                        v-if="unconfigProductsCount > 0"
                        >{{ unconfigProductsCount }}</v-chip
                    ></v-btn
                >
                <v-btn small active-class="success--text">Configured</v-btn>
                <v-btn small active-class="warning--text">Ignored</v-btn>
                <v-btn small>All</v-btn>
            </v-btn-toggle>
        </v-row>

        <!-- New Product Dialog-->
        <ProductEditDialog
            :dialog.sync="newProductDialog"
            v-on:item-created="onProductCreated"
        ></ProductEditDialog>

        <!-- Product Dialog -->
        <v-dialog v-model="productDialog" scrollable persistent>
            <v-card tile>
                <v-toolbar flat dark color="primary">
                    <v-btn icon dark @click="closeProductDialog">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{
                        selectedProductNode
                            ? selectedProductNode.name
                            : "Product"
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="goToProductDetail(selectedProductNodeId)"
                    >
                        <v-icon>launch</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mx-0 px-0">
                    <ProductDetailComponent
                        v-if="selectedProductNodeId"
                        :productNodeId="selectedProductNodeId"
                        v-on:product-items-updated="refreshCurrentPage"
                        v-on:item-deleted="onProductDeleted"
                    ></ProductDetailComponent>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Delete Dialog -->
        <!-- <DeleteDialog
            :dialog.sync="deleteDialog"
            :item="deletedProduct"
            v-on:confirmed="deletingConfirmed"
        >
            <template v-slot:title>Delete - {{ deletedProduct ? deletedProduct.node.name : "" }}</template>
            <template v-slot:content>Are you sure you want to delete this product?</template>
        </DeleteDialog>-->

        <v-row class="ma-0">
            <v-col cols="12" class="pt-0">
                <v-hover>
                    <template v-slot="{ hover }">
                        <v-card :elevation="hover ? 6 : 1">
                            <!-- Header -->
                            <v-card-title class="pb-0">
                                <v-icon color="primary" class="mx-2"
                                    >local_offer</v-icon
                                >Products
                                <v-btn
                                    v-if="hasPermission('view_product')"
                                    icon
                                    fab
                                    small
                                    class="mr-5"
                                    @click="goToProductSettings()"
                                >
                                    <v-icon>settings</v-icon>
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4">
                                    <v-row justify="end" align="end">
                                        <v-text-field
                                            dense
                                            v-model="search"
                                            append-outer-icon="refresh"
                                            @click:append-outer="
                                                refreshCurrentPage()
                                            "
                                            label="Search"
                                            clearable
                                            hide-details
                                            class="mx-2"
                                            @keydown.enter="
                                                refreshCurrentPage()
                                            "
                                            @click:clear="onClearSearch()"
                                        ></v-text-field>
                                    </v-row>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-btn
                                    v-if="hasPermission('add_product')"
                                    color="primary"
                                    dark
                                    outlined
                                    rounded
                                    small
                                    @click="newProductDialog = true"
                                    >New Product</v-btn
                                >
                                <!-- <v-speed-dial
                                    direction="left"
                                    transition="slide-x-reverse-transition"
                                >
                                    <template v-slot:activator>
                                        <v-btn small text fab>
                                            <v-icon>more_vert</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-btn
                                        color="primary"
                                        dark
                                        fab
                                        x-small
                                        @click="newProductDialog=true"
                                    >
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </v-speed-dial>-->
                            </v-card-title>

                            <!-- Product table -->
                            <v-container fluid>
                                <v-data-table
                                    :headers="headers"
                                    :loading="
                                        $apollo.queries.tenantProducts.loading
                                    "
                                    :items="tenantProducts.edges"
                                    :options.sync="dataTableOptions"
                                    loading-text="Loading... Please wait"
                                    :server-items-length="
                                        tenantProducts.totalCount
                                    "
                                    :items-per-page="defaultItemsPerPage"
                                    :footer-props="{
                                        'items-per-page-options': [
                                            10,
                                            25,
                                            50,
                                            75,
                                            100
                                        ],
                                        'disable-pagination':
                                            $apollo.queries.tenantProducts
                                                .loading
                                    }"
                                >
                                    <template
                                        v-slot:item.node.updatedAt="{ item }"
                                    >
                                        <span>{{
                                            new Date(
                                                item.node.updatedAt
                                            ).toLocaleString()
                                        }}</span>
                                    </template>
                                    <template
                                        v-slot:item.node.isDynamic="{ item }"
                                    >
                                        <v-chip
                                            small
                                            color="primary"
                                            v-if="item.node.isDynamic"
                                            >Dynamic</v-chip
                                        >
                                        <span v-else class="grey--text"
                                            >NO</span
                                        >
                                    </template>
                                    <template
                                        v-slot:item.node.productItemSet.totalCount="{
                                            item
                                        }"
                                    >
                                        <v-chip
                                            small
                                            color="error"
                                            v-if="
                                                item.node.productItemSet
                                                    .totalCount == 0
                                            "
                                            >No Plant</v-chip
                                        >
                                        <span v-else>{{
                                            item.node.productItemSet.totalCount
                                        }}</span>
                                    </template>
                                    <template v-slot:item.action="{ item }">
                                        <!-- <v-btn
                                            outlined
                                            rounded
                                            small
                                            color="primary"
                                            @click="openProductDialog(item.node)"
                                        >View</v-btn>-->
                                        <v-toolbar flat color="transparent">
                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs
                                                    }"
                                                >
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="
                                                            openProductDialog(
                                                                item.node
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            >remove_red_eye</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                                <span>View</span>
                                            </v-tooltip>
                                            <v-btn
                                                icon
                                                color="primary"
                                                @click="
                                                    goToProductDetail(
                                                        item.node.id
                                                    )
                                                "
                                            >
                                                <v-icon>launch</v-icon>
                                            </v-btn>
                                            <v-tooltip
                                                top
                                                v-if="item.node.isIgnored"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs
                                                    }"
                                                >
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="
                                                            ignoreProduct(
                                                                item.node.id,
                                                                false
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            >settings_backup_restore</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                                <span>Restore</span>
                                            </v-tooltip>
                                            <v-tooltip
                                                top
                                                v-if="!item.node.isIgnored"
                                            >
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs
                                                    }"
                                                >
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click="
                                                            ignoreProduct(
                                                                item.node.id,
                                                                true
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            >not_interested</v-icon
                                                        >
                                                    </v-btn>
                                                </template>
                                                <span>Ignore</span>
                                            </v-tooltip>
                                            <!-- <v-icon small @click="deletingProduct(item)">delete</v-icon> -->
                                        </v-toolbar>
                                    </template>
                                </v-data-table>
                            </v-container>
                        </v-card>
                    </template>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import ProductEditDialog from "@/components/products/ProductEditDialog.vue";
import ProductDetailComponent from "@/components/products/ProductDetailComponent.vue";
// import DeleteDialog from "@/components/base/DeleteDialog.vue";

// const fragments = {
//     product: gql`
//         fragment product on Product {
//             id
//             name
//             externalId
//             externalCode
//             isDynamic
//             productCategory {
//                 id
//                 name
//             }
//         }
//     `
// };

export default {
    name: "product-list-page",
    components: {
        ProductEditDialog,
        ProductDetailComponent
        // DeleteDialog
    },

    apollo: {
        unconfigProductsCount: {
            query: gql`
                query unconfigProductsCount {
                    tenantProducts(
                        isPlantsConfigured_Iexact: false
                        isIgnored_Iexact: false
                    ) {
                        totalCount
                    }
                }
            `,
            variables() {
                return {};
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantProducts.totalCount,
            skip: false,
            pollInterval: 60000 // ms
        },
        tenantProducts: {
            query: gql`
                query tenantProducts(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $orderBy: String
                    $search: String
                    $isPlantsConfigured: Boolean
                    $isIgnored: Boolean
                ) {
                    tenantProducts(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        search: $search
                        isPlantsConfigured_Iexact: $isPlantsConfigured
                        isIgnored_Iexact: $isIgnored
                        orderBy: $orderBy
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                name
                                externalId
                                externalCode
                                printPriority
                                isDynamic
                                isPlantsConfigured
                                isIgnored
                                productCategory {
                                    id
                                    name
                                }
                                productItemSet {
                                    totalCount
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10,
                    isPlantsConfigured: this.isPlantsConfigured,
                    isIgnored: this.isIgnored
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: data => data.tenantProducts,
            skip: true,
            pollInterval: 60000 // ms
        }
    },

    data: function() {
        return {
            newProductDialog: false,
            deleteDialog: false,

            productDialog: false,
            selectedProductNodeId: null,
            selectedProductNode: null,

            defaultItemsPerPage: 25,
            dataTableOptions: {},
            page: 1,

            unconfigProductsCount: 0,
            tenantProducts: {},

            deletedProduct: null,

            productFilterTab: 0,
            search: "",

            headers: [
                {
                    text: "Category",
                    value: "node.productCategory.name",
                    sortable: true
                },
                {
                    text: "Product",
                    align: "left",
                    value: "node.name",
                    sortable: true
                },
                {
                    text: "External Code",
                    value: "node.externalCode",
                    sortable: true
                },
                {
                    text: "External ID",
                    value: "node.externalId",
                    sortable: true
                },
                {
                    text: "Is Dynamic",
                    value: "node.isDynamic",
                    sortable: true
                },
                {
                    text: "Print Priority",
                    value: "node.printPriority",
                    sortable: true
                },
                {
                    text: "#Plants",
                    value: "node.productItemSet.totalCount",
                    sortable: false
                },
                // {
                //     text: "Sales Price",
                //     value: "node.salesPrice"
                // },
                {
                    text: "Actions",
                    value: "action",
                    width: "120px",
                    align: "center",
                    sortable: false
                }
            ],
            editedIndex: -1
        };
    },
    computed: {
        // products: function() {
        //     return this.$store.state.products.products;
        // },
        editedProduct: function() {
            if (this.editedIndex > -1) {
                return this.tenantProducts[this.editedIndex];
            } else {
                return null;
            }
        },
        isPlantsConfigured() {
            return this.productFilterTab == 1
                ? true
                : this.productFilterTab == 0
                ? false
                : null;
        },
        isIgnored() {
            return this.productFilterTab == 2
                ? true
                : this.productFilterTab == 3
                ? null
                : false;
        }
    },
    watch: {
        // page(newValue, oldValue) {
        //     if (newValue > oldValue) {
        //         this.getNextPage();
        //     } else {
        //         this.getPrevPage();
        //     }
        // },
        // itemsPerPage() {
        //     this.refreshCurrentPage();
        // },
        dataTableOptions: {
            handler() {
                this.refreshCurrentPage();
            },
            deep: true
        },
        productFilterTab(value) {
            if (value != null) {
                localStorage.setItem("productFilterTab", value);

                this.refreshCurrentPage();
            }
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    mounted() {
        if (this.$route.query.filter === "toconfig") {
            this.productFilterTab = 0;
        } else if (localStorage.getItem("productFilterTab") != null) {
            this.productFilterTab = parseInt(
                localStorage.getItem("productFilterTab")
            );
        } else {
            this.productFilterTab = 1;
        }
    },
    methods: {
        onClearSearch() {
            this.search = "";

            this.refreshCurrentPage();
        },

        refreshCurrentPage() {
            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.dataTableOptions;

            // console.log(this.dataTableOptions);

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantProducts.pageInfo.startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantProducts.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.productCategory.name":
                    _orderBy = "productCategoryName";
                    break;
                case "node.name":
                    _orderBy = "productName";
                    break;
                case "node.externalCode":
                    _orderBy = "externalCode";
                    break;
                case "node.externalId":
                    _orderBy = "externalId";
                    break;
                case "node.printPriority":
                    _orderBy = "printPriority";
                    break;
                case "node.isDynamic":
                    _orderBy = "isDynamic";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            this.$apollo.queries.tenantProducts.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                orderBy: _orderBy,
                search: this.search,
                isPlantsConfigured: this.isPlantsConfigured,
                isIgnored: this.isIgnored
            });

            // set skip false to execute the query
            this.$apollo.queries.tenantProducts.skip = false;
            this.$apollo.queries.tenantProducts.refresh();

            // update this.page
            this.page = page;
        },

        openProductDialog(product) {
            this.selectedProductNodeId = product.id;
            this.selectedProductNode = product;
            this.productDialog = true;
            // this.$router.push({
            //     name: "product-detail",
            //     params: { id: product.id }
            // });
        },

        closeProductDialog() {
            this.productDialog = false;
            this.selectedProductNodeId = null;
            this.selectedProductNode = null;
            this.$apollo.queries.tenantProducts.refresh();
            // this.refreshCurrentPage();
        },

        onProductCreated(response) {
            this.refreshCurrentPage();

            this.goToProductDetail(response.id);
        },

        onProductDeleted() {
            // this.refreshCurrentPage();
            this.closeProductDialog();
        },

        goToProductDetail(productNodeId) {
            // this.$router.push({
            //     name: "product-detail",
            //     params: { id: productNodeId }
            // });

            let routeData = this.$router.resolve({
                name: "product-detail",
                params: { id: productNodeId }
            });
            window.open(routeData.href, "_blank");
        },

        goToProductSettings() {
            this.$router.push({
                name: "product-settings"
            });
        },

        ignoreProduct(productNodeId, isIgnored) {
            this.$apollo
                .mutate({
                    // Query
                    mutation: gql`
                        mutation ignoreProduct($input: IgnoreProductInput!) {
                            ignoreProduct(input: $input) {
                                product {
                                    id
                                    isIgnored
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        input: {
                            id: productNodeId,
                            isIgnored: isIgnored
                        }
                    }
                })
                .then(() => {
                    // this.isLoadingPlannedTaskPhases = false;
                    // console.log(response);

                    // show snackbar
                    const payload = {
                        color: "success",
                        message: `Updated!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);

                    this.$apollo.queries.unconfigProductsCount.refresh();
                    this.refreshCurrentPage();
                })
                .catch(error => {
                    // this.isLoadingPlannedTaskPhases = false;

                    // Error
                    console.error(error);

                    // show snackbar
                    const payload = {
                        color: "error",
                        message: `Failed!`
                    };
                    this.$store.dispatch("snackbar/showMessage", payload);
                })
                .finally(() => {
                    // this.loadingOperatingCostsKey = false;
                });
        }

        // deletingProduct(item) {
        //     this.deletedProduct = item;
        //     this.deleteDialog = true;
        // },

        // deletingConfirmed(item) {
        //     if (item) {
        //         const payload = {
        //             id: item.node.id
        //         };
        //         this.$store
        //             .dispatch("products/deleteProduct", payload)
        //             .then(response => {
        //                 // refresh products
        //                 this.fetchProducts();

        //                 // close delete dialog
        //                 this.deleteDialog = false;

        //                 // show snackbar
        //                 const payload = {
        //                     color: "success",
        //                     message: `${response.name} is deleted!`
        //                 };
        //                 this.$store.dispatch("snackbar/showMessage", payload);
        //             })
        //             .catch(error => {
        //                 this.error = error.graphQLErrors[0].message;
        //             });
        //     }
        // }
    }
};
</script>